import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import queryString from "query-string";
import $ from "jquery";
import CleanButton from "../components/CleanButton";
import { configs } from "../../config";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useGetPaymentConfigMutation } from "../../state/globalApi";
import { buildPaymentConfigRequest } from "../../state/connect-api";

declare global {  
  interface Window {
    AuthorizeNetIFrame: { onReceiveCommunication: (queryStr: string) => void };
    AuthorizeNetPopup: any;
  }
}

type TransactionResponse = {
  accountNumber: string;
  accountType: "Visa" | "MasterCard" | "Discover" | "AmericanExpress" | "DinersClub" | "JCB" | "eCheck";

  authCode: string;
  avsResultCode: "A" | "B" | "E" | "G" | "N" | "P" | "R" | "S" | "U" | "W" | "X" | "Y" | "Z";
  cvvResultCode: "M" | "N" | "P" | "S" | "U";
  errors?: ReadonlyArray<{ errorCode: string; errorText: string }>;
  messages: ReadonlyArray<{ code: string; description: string }>;
  responseCode: "1" | "2" | "3" | "4";
  transId: string;
};

type Message =
  | {
      action: "resizeWindow";
      width: number;
      height: number;
    }
  | {
      action: "cancel";
    }
  | {
      action: "transactResponse";
      response: string;
    };

function isValidMessage(o: unknown): o is Message {
  return typeof o === "object" && o !== null;
}

function isValidTransaction(o: unknown): o is TransactionResponse {
  return o !== null && o !== undefined && typeof o === "object";
}

const AuthorizeNetPostUrl = {
  production: "https://accept.authorize.net/payment/payment",
  sandbox: "https://test.authorize.net/payment/payment"
};

type AcceptHostedProps = {
  style?: React.CSSProperties;
  className?: string;
  formToken: string;
  mode?: "sandbox" | "production";
  type?: "redirect" | "iframe";
  amount: number;
  isCivil?: boolean;

  onReceiveCommunication?: (queryStr: string) => void;
  onMessage?: (message: Message) => void;

  onCancel?: () => void;
  onResize?: (width: number, height: number) => void;
  onTransact?: (response: TransactionResponse) => void;
};

export const AcceptHosted: React.FC<AcceptHostedProps> = ({
  formToken,
  mode = "sandbox",
  type = "iframe",
  onMessage,
  style,
  className,
  children,
  onReceiveCommunication,
  onCancel,
  onResize,
  amount,
  isCivil = false
}) => {
  const history = useNavigate();
  const [communicatorReady, setCommunicatorReady] = useState(false);
  const [getPaymentConfig] = useGetPaymentConfigMutation();
  const { activeCaseNumber, activeTransactionId } = useSelector((state: RootState) => state.global);
  if (!window.AuthorizeNetPopup) window.AuthorizeNetPopup = {};
  if (!window.AuthorizeNetPopup.options)
    window.AuthorizeNetPopup.options = {
      onPopupClosed: null
    };

  function AuthorizeNetPopupclosePopup() {
    window.removeEventListener('resize', centerPopup);

    document.getElementById("divAuthorizeNetPopupScreen").style.display = "none";
    document.getElementById("divAuthorizeNetPopup").style.display = "none";

    //document.getElementById("iframeAuthorizeNet").setAttribute("src", "https://web1.civicacmi.com/democourtcs/Site/ApiPaymentProviders/AuthorizeV2/AuthorizeCommunicator2.html");
    //(document.getElementById("btnOpenAuthorizeNetPopup") as HTMLButtonElement).disabled = false;
    if (window.AuthorizeNetPopup.options.onPopupClosed) window.AuthorizeNetPopup.options.onPopupClosed();
  }

  const onTransact = async (response) => {
    const configRequest = buildPaymentConfigRequest("authorize");
    const paymentConfig = await getPaymentConfig(configRequest).unwrap();
    const configValues = paymentConfig.Data;
    const configObject = configValues.reduce((acc, item) => {
      return {
        ...acc,
        [item.ConfigName]: item.ConfigValue
      };
    }, {});
    const url = JSON.parse(configObject.postbackURL).url;
    const values = JSON.parse(response);
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    form.style.display = "none";
    const appendHiddenField = (name: string, value: string) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };
    appendHiddenField("postback", response);
    appendHiddenField("clientID", configObject.clientID);
    appendHiddenField("awcApp", "CT");
    appendHiddenField("appTransID", activeCaseNumber + "-" + activeTransactionId);
    appendHiddenField("sessionID", configs.session);
    appendHiddenField("clientName", values.merchantName); //court name);
    document.body.appendChild(form);
    form.submit();
  };

  function centerPopup() {
    const d = document.getElementById("divAuthorizeNetPopup");
    d.style.display = "block";
    d.style.position = "fixed";
    d.style.transform = "none";
    const rect = d.getBoundingClientRect();
    d.style.setProperty('margin', '0', 'important');
    const left = Math.max((window.innerWidth - rect.width) / 2, 0);
    const top = Math.min((window.innerHeight - rect.height), rect.height*3);
    d.style.left = `${left}px`;
    d.style.top = `${top}px`;
  }
  useEffect(() => {
    const listener = (e: MessageEvent) => {
      window.addEventListener("message", listener);
      return () => window.removeEventListener("message", listener);
    };
  }, []);
  function AuthorizeNetPopupopenPopup() {
    const popup = document.getElementById("divAuthorizeNetPopup");
    const popupScreen = document.getElementById("divAuthorizeNetPopupScreen");
    const form = document.getElementById('formAuthorizeNetPopup') as HTMLFormElement;
    $("#popupToken").val($("#inputtoken").val());
    form.action = AuthorizeNetPostUrl[mode];

    form.submit();
    popup.style.display = "";
    popupScreen.style.display = "";
    window.addEventListener('resize', centerPopup);
    centerPopup();
  }
  useEffect(() => {
    window.AuthorizeNetIFrame = {
      onReceiveCommunication: (queryStr) => {
        onReceiveCommunication && onReceiveCommunication(queryStr);
        const message: unknown = queryString.parse(queryStr);
        if (isValidMessage(message)) {
          onMessage && onMessage(message);
          switch (message.action) {
            case "transactResponse":
              const json = JSON.parse(message.response);
              if (isValidTransaction(json)) {
                onTransact(message.response);
                //AuthorizeNetPopupclosePopup();
                //history("/home");
              }
              break;

            case "resizeWindow":
              onResize && onResize(message.width, message.height);
              break;

            case "cancel":
              onCancel && onCancel();
              AuthorizeNetPopupclosePopup();
              history("/home");
              break;
          }
        }
      }
    };
    return () => {
      delete window.AuthorizeNetIFrame;
    };
  }, []);

  const [submitted, setSubmitted] = useState(false);

  const handlePopUpForm = async () => {
    AuthorizeNetPopupopenPopup();
  };

  const formTrigger = children ? (
    children
  ) : (
    <CleanButton icon="dollar-sign" onClick={handlePopUpForm}>
      Pay
    </CleanButton>
  );

  switch (type) {
    case "iframe":
      return (
        <div style={style} className={className}>
          <form id="formAuthorizeNetPopup" onSubmit={() => setSubmitted(true)} method={"POST"} action={AuthorizeNetPostUrl[mode]} target={"iframeAuthorizeNet"}>
            <input name="token" type={"hidden"} value={formToken} />
            {!submitted && formTrigger}
          </form>
          <input type="hidden" id="popupToken" name="token" value={formToken} />
          <input type="hidden" id="inputtoken" value={formToken} />
          <div id="divAuthorizeNetPopup" style={{ display: "none" }} className="AuthorizeNetPopupGrayFrameTheme">
            <div className="AuthorizeNetPopupOuter">
              <div className="AuthorizeNetPopupTop">
                <div className="AuthorizeNetPopupClose">
                  <a href="javascript:;" onClick={() => AuthorizeNetPopupclosePopup()} title="Close">
                    <b>X</b>
                  </a>
                </div>
              </div>
              <div className="AuthorizeNetPopupInner">
                <iframe
                  id={"iframeCommunicator"}
                  name={"iframeCommunicator"}
                  sandbox="allow-modals allow-same-origin allow-scripts unsafe-inline"
                  src={`${window.location.origin + (configs.basePath ?? "/")}IFrameCommunicator.html`}
                  style={{ display: "none" }}
                  frameBorder={0}
                  width={"100%"}
                  onLoad={() => setCommunicatorReady(true)}
                />
                {communicatorReady && <iframe src="about:blank" sandbox="allow-modals allow-same-origin allow-scripts" name="iframeAuthorizeNet" id="iframeAuthorizeNet" />}
              </div>
              <div className="AuthorizeNetPopupBottom">
                <div className="AuthorizeNetPopupLogo" title="Powered by Authorize.Net"></div>
              </div>
              <div id="divAuthorizeNetPopupScreen" style={{ display: "none" }}></div>
            </div>
          </div>
        </div>
      );

    case "redirect":
      return (
        <form style={style} className={className} method={"POST"} action={AuthorizeNetPostUrl[mode]}>
          <input type={"hidden"} name={"token"} value={formToken} />
          {formTrigger}
        </form>
      );
  }
};

export default AcceptHosted;
